var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXperMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.174 41.9435H35.6894C39.5246 41.3318 40.5557 40.038 40.959 36.5092V15.1014C41.0905 14.2076 40.9146 13.7435 40.3003 12.9606L33.7133 6.20888C32.8828 5.21151 32.4129 5.07339 31.5725 5.05615H15.1049C12.291 5.56419 11.1654 6.5438 10 9.50239V16.9128",
    stroke: "#2E3848",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 41.1411C7.19425 37.4784 5.95276 35.8892 6.00137 34.0002C6.06577 31.4974 7.34545 29.8725 11 26.8594",
    stroke: "#2E3848",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17.7875C25.0446 20.7176 26.0378 21.989 25.9989 23.5002C25.9474 25.5025 24.9236 26.8024 22 29.2129",
    stroke: "#2E3848",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXperMark);
export default __webpack_public_path__ + "static/media/xper-mark.e2c747e548398727547bb5242eae24ef.svg";
export { ForwardRef as ReactComponent };